// YunPlayer.js

import { useState, useEffect, useRef, memo } from 'react';
import './YunPlayer.css';

import YunSection from '../YunSection/YunSection';
import YunIcon from '../YunIcon/YunIcon';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// import { generateRandomByteArray } from './yunSpectrum_a';
import YunSprctrun from './YunSpectrum';

import { getPlayerName } from '../../App/tools';

import { debounce } from '../../../utils/index';

import { cppGetAudioDeviceList } from '../../../api/cpp';

import defaultPlayerIcon from './default.png';
import kugou from './kugou.png';
import qq from './qqmusic.png';
import kuwo from './kuwo.png';
import netease from './neteasemusic.png';
import soda from './soda.png';
import wesing from './quanmin.png';
import baidu from './baidumusic.png';
import xiami from './xiami.png';
import fanxing from './fanxing.png';
import mvbox from './mvbox.png';
import foobar from './foobar.png';

import spkIcon from './spk.png';
import smtcIcon from './smtc.png';

//酷狗音乐:kugou
//QQ音乐:qq
//酷我音乐:kuwo
//网易云音乐:netease
//全民K歌:wesing
//千千音乐:baidu
//虾米音乐:xiami
//酷狗直播伴侣:fanxing
//MvBox:mvbox
//Foobar2000:foobar

const YunPlayer = memo(function(props) {
    const [players, setPlayers] = useState([]);
    const [spkList, setSpkList] = useState([]);
    const [spectrumData, setSpectrumData] = useState([]);
    const { playerData, setCurrentPlayer, pageset, curSpk, setCurSpk, clearAiEm, isSMTC, setIsSMTC, } = props;

    const d_clearAiEm = debounce(clearAiEm, 500)
    // useEffect(() => {
    //     setSpectrumData([29, 27, 32, 19, 17, 18, 10, 11, 14, 16, 12, 9, 11, 9, 7, 3, 7, 9, 2, 5, 7, 0])
    // }, []);

    const throttle = useRef(Date.now());

    useEffect(() => {
        setPlayers(preArray => {
            if (playerData && playerData.player) {
                const playersTemp = JSON.parse(JSON.stringify(preArray))
                const index = preArray.findIndex(ele => {
                    return ele.player === playerData.player
                })
                if (index !== -1) {
                    playersTemp[index] = playerData
                } else {
                    playersTemp.push(playerData)
                }
                return playersTemp
            }
            return preArray
        })
        return () => {
            window.onPlayerOffline = null;
            window.onAudioFFTChange = null;
        }
    }, [playerData])

    useEffect(() => {
        try {
            const list = JSON.parse(cppGetAudioDeviceList());
            if (Array.isArray(list)) {
                setSpkList(list);
            }
        } catch (error) {}
    }, [])

    function getLogoByPlayer(player, spk, smtc) {
        if (spk) {
            return spkIcon
        }
        if (smtc) {
            return smtcIcon
        }
        let logo;
        switch (player) {
            case 'kugou':
                logo = kugou
                break;
            case 'qq':
                logo = qq
                break;
            case 'kuwo':
                logo = kuwo
                break;
            case 'netease':
                logo = netease
                break;
            case 'soda':
                logo = soda
                break;
            case 'wesing':
                logo = wesing
                break;
            case 'baidu':
                logo = baidu
                break;
            case 'xiami':
                logo = xiami
                break;
            case 'fanxing':
                logo = fanxing
                break;
            case 'mvbox':
                logo = mvbox
                break;
            case 'foobar':
                logo = foobar
                break;
            default:
                logo = defaultPlayerIcon
                break;
        }
        return logo;
    }
    function fomatPlayerName(player) {
        return getPlayerName(player) || ""
    }
    // 播放器下线
    try {
        window.onPlayerOffline = (player) => {
            if (!player) {
                return false;
            }
            const playersTemp = JSON.parse(JSON.stringify(players))
            const index = players.findIndex(ele => {
                return ele.player === player
            })
            if (index !== -1) {
                playersTemp.splice(index, 1);
            } else {
                return false
            }
            if (playersTemp && playersTemp.length) {
                if (player === playerData.player) {
                    setCurrentPlayer(playersTemp[0]);
                }
            } else {
                setCurrentPlayer({});
            }
            setPlayers(playersTemp)
        }
    } catch (error) {
    }

    // 监听频谱
    try {
        window.onAudioFFTChange = (fftdb_str) => {
            const fftdb = JSON.parse(fftdb_str)            
            if (fftdb.isSlient) {
                if (curSpk) {
                    d_clearAiEm()
                }
            } else {
                const n = Date.now()
                if (n - throttle.current > 150) {
                    throttle.current = n
                    const fft = formatFft(fftdb.fft, fftdb.db)
                    setSpectrumData(fft)
                }
            }
        }
    } catch (error) {
    }

    // 格式化频谱数据
    const formatFft = (fftAry, db, max = 58, dbMax = -10, dbMin = -60) => {
        let minValue = 0
        let maxValue = 0
        for (let i = 0; i < fftAry.length; i++) {
            const ele = fftAry[i] || 0;
            if (ele < minValue) minValue = ele;
            if (ele > maxValue) maxValue = ele;
        }
        if (minValue === maxValue) {
            return fftAry.map(() => 0)
        }
        const scale = max / (maxValue - minValue);
        let dbScale = (db - dbMin) / (dbMax - dbMin);
        dbScale = dbScale < 0 ? 0 : dbScale > 1 ? 1 : dbScale;
        return fftAry.map((ele) => {
            ele = ele || 0
            const scaleValue = Math.round((ele - minValue) * scale * dbScale)
            return scaleValue
        })
    }

    // 切换播放器
    const changeSelect = (e, child) => {
        if (e.preventDefault) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();

        if (child.props.value === "spk") {
            if (curSpk) {
                return
            }
            setCurrentPlayer({});
            setIsSMTC(false);
            setCurSpk(spkList[0] || "not-found-spk");
            return
        }
        if (child.props.value === "smtc") {
            if (isSMTC) {
                return
            }
            setCurrentPlayer({});
            setCurSpk("");
            setIsSMTC(true);
            return
        }
        if (child.props.value === playerData.player) {
            return false
        }
        const curPlayer = players.find(ele => {
            return ele.player === child.props.value
        })
        setCurrentPlayer(curPlayer);
        setCurSpk("");
        setIsSMTC(false);
    }
    // 切换扬声器
    const changeSelectSpk = (e, child) => {
        if (e.preventDefault) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
        setCurSpk(child.props.value);
    }
    
    if (!pageset.player) {
        return null
    }
    let musicInfoEle = (
        <div className="MusicInfo">
            <p className="MusicName CursorDefault">请打开播放器</p>
            <p className="MusicAuthor HoverColor MainColor CursorDefault"></p>
        </div>
    )
    if ((playerData && playerData.player) || isSMTC) {
        musicInfoEle = (
            <div className="MusicInfo">
                <p className="MusicName CursorDefault" title={playerData.musicName}>{playerData.musicName}</p>
                <p className="MusicAuthor HoverColor MainColor CursorDefault" title={playerData.musicAuthor}>{playerData.musicAuthor}</p>
            </div>
        )
    } else if (curSpk) {
        if (curSpk === "not-found-spk") {
            musicInfoEle = (
                <div className="MusicInfo">
                    <p className="MusicName CursorDefault">扬声器</p>
                    <p className="MusicAuthor HoverColor MainColor CursorDefault">没有发现扬声器设备</p>
                </div>
            )
        } else {
            musicInfoEle = (
                <div className="MusicInfo">
                    <div title={curSpk} className="SpkSelect YunSelect MainColor2">
                        <div className="Label">
                            扬声器
                        </div>
                        <div className="SelectLabel HoverColor MainColor">
                            {curSpk}
                        </div>
                        <YunIcon icon="expand"></YunIcon>
                        <Select value="" onChange={changeSelectSpk}>
                            {
                                spkList.map(ele => {
                                    return (
                                        <MenuItem className="SelectItem" key={ele} value={ele}>{ele}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </div>
                </div>
            )
        }
    }
    return (
        <div className="YunPlayer YunComponent">
            {/* {playerList} */}
            <YunSection width="200" height="60">
                <div className="PlayerBox PlayerBoxItem">
                    <div className="PlayerLogo">
                        <div className="PlayerLogoBox">
                            <img src={getLogoByPlayer(playerData.player, curSpk, isSMTC)} alt="player" />
                        </div>
                        <div className="PlayerChangeIconBox">
                            <YunIcon iconClass="PlayerChangeIcon" icon="pull_down"></YunIcon>
                            <Select value="" onChange={changeSelect}>
                                {
                                    players.map(ele => {
                                        return (
                                            <MenuItem className="SelectItem" key={ele.player} value={ele.player}>{fomatPlayerName(ele.player)}</MenuItem>
                                        )
                                    })
                                }
                                <MenuItem className="SelectItem" value="spk">扬声器</MenuItem>
                                <MenuItem className="SelectItem" value="smtc">系统媒体</MenuItem>
                            </Select>
                        </div>
                    </div>
                    {musicInfoEle}
                </div>
                <div className="PlayerBg">
                    <YunSprctrun data={spectrumData}></YunSprctrun>
                </div>
            </YunSection>
        </div>
    )
})

export default YunPlayer;
